import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello everyone! My name is <span className="purple">Josephin Nova</span>, 
            and I'm from <span className="purple">Semarang, Indonesia</span>.
            <br />
            I am currently a <span className="purple">Computer Science student</span> who is 
            enthusiastic about creating tech solutions that are both functional and dependable.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Dedicate your efforts to building useful solutions!"{" "}
          </p>
          <footer className="blockquote-footer">Josephin Nova</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;